import { Box, IconButton, Typography, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DynamicIcon } from "../DynamicIcon";
import { ReactNode, type JSX } from "react";

export default function DrawerHeader({
  icon,
  iconElement,
  header,
  subheader,
  onClose,
  customRightHeaderElement,
}: Readonly<{
  icon?: string;
  iconElement?: ReactNode;
  header?: string | undefined;
  subheader?: string | undefined;
  onClose: () => void;
  customRightHeaderElement?: JSX.Element | string;
}>) {
  const theme = useTheme();

  return (
    <Box
      className="flex items-center justify-between"
      py={2}
      pl={2}
      pr={1}
      bgcolor={"table.header"}
    >
      <Box className="flex items-center">
        {iconElement ?? (
          icon && (
            <DynamicIcon
              iconName={icon}
              size="small"
              color={{ color: theme.palette.text.secondary }}
            />
          )
        )}
        {(header || subheader) && (
          <Box sx={{ pl: 2 }}>
            {header && (
              <Typography variant="body1" maxWidth={"500px"}>
                {header}
              </Typography>
            )}
            {subheader && (
              <Typography color="textSecondary" component="div" variant="body2">
                {subheader}
              </Typography>
            )}
          </Box>
        )}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {customRightHeaderElement}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: theme.palette.text.secondary }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
}